export default {
    agreement_categories: "Müqavilə kateqoriyaları",
    app_code: "Təşəbbüs proqramı kodu",
    authentication_login: "Doğrulama girişi",
    authentication_password: "Doğrulama parolu",
    cod_no: "Kod NO",
    credentials_of_authorized_person: "Səlahiyyətli şəxsin avtorizasiyası",
    director: "Direktor",
    do_you_confirm_sending_feedback_url_to_patient_messenger: "Messengerdə ​​xəstəyə rəy yazmaq üçün linkin göndərilməsini təsdiq edirsinizmi?",
    do_you_confirm_sending_receipt_to_patient_messenger: "Qəbzin xəstənin mesajına göndərilməsini təsdiqləyirsiniz?",
    employee_login: "İşçi girişi",
    employee_password: "İşçi parolu",
    fdoc_instruction: "Xidmətin düzgün işləməsi üçün IP ünvanını FDoc menecerinə ötürün, ona qarmaqlar/sorğular daxil olacaq: <code>{ipaddress}</code>. Qəbul etmək istədiyiniz hadisələri də adlandırın: <code>SetStatus, SetStatusMessage, SetStatusPackageByClient</code>",
    fdoc_multiple_signers_instruction: "Personal bölməsində, işçi redaktəsində, FDoc sekmesinde, FDoc sistemindən işçinin girişi və parolu göstərilməlidir.",
    files: "Fayllar",
    files_being_uploaded: "Fayllar yüklənir. Yükləmə tamamlanana qədər səhifəni bağlamayın.",
    fill_questionary: "Sorğunu doldurun",
    first_new: "Əvvəlcə yeniləri",
    first_old: "Əvvəlcə köhnələri",
    gallery: "Qalereya",
    header_in_akt: "Göstərilən xidmətlərin aktında qapaq",
    multiple_signers_support: "Birdən çox imzalayanın dəstəyi",
    options: "Seçimlər",
    or_folder_with_dcm_files: "və ya DCM faylları olan qovluq",
    select_folder: "Qovluq seçin",
    send_receipt_to_messenger: "Qəbzi xəstənin mesajına göndərin",
    sign_selected_via_vendor: "{vendor} vasitəsilə seçilmiş imzala",
    table: "Cədvəl"
}
